import { render, staticRenderFns } from "./ContentStoreProductTemplate.vue?vue&type=template&id=c3fb4baa"
import script from "./ContentStoreProductTemplate.vue?vue&type=script&lang=js"
export * from "./ContentStoreProductTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports